<template>
    <div>
        <div id="entitySkillPopover" class="legends-popover entity_skill_popover"></div>
        <b-popover ref="skillProgressPopover" container="entitySkillPopover" :target="skillProgressTargetId" :show.sync="$parent.showStreamSkillProgressPopup" :no-fade="true" triggers="click" :placement="'right'">
            <template v-slot:title>
                <div class="header-content-row program">
                 <span class="title"> Required Skills as of {{lastUpdatedDateTime(progress)}} </span>
                    <button class="btn_close" aria-label="close" @click="closeSkillProgressPopup">
                       <span class="ic-close"></span>
                    </button>
                </div>
            </template>

                <div class="text-center"><span class="title"><strong>{{title}}</strong></span></div>

            <template v-show="isPieChartGenerated">
                <div class="popup_grph">
                    <div class="skill_chart career_credit" id="skillProgressChart"></div>
                    <div class="skilllegend_detail career-lg">
                        <div class="status_row"><span class="lg_blc completed"></span>Completed</div>
                        <div class="status_row"><span class="lg_blc in_progress"></span>In Progress</div>
                        <div class="status_row"><span class="lg_blc in_the_plan"></span>In the Plan</div>
                        <div class="status_row"><span class="lg_blc credits_needed"></span>Credits Needed</div>
                    </div>
                </div>
            </template>

            <div class="popup-footer">

                <div class="updated_time">
                    <span>Current Date {{currentDateTime()}}</span>
                </div>

                <div class="updated_time">
                    <span>Last Calculated On {{lastUpdatedDateTime(progress)}}</span>
                </div>

                <div class="calculate_btn">
                    <button class="btn btn-primary" @click="recalculateSkillProgress">Re-calculate now</button>
                </div>

            </div>

            <div class="loading-spinner">
                <b-modal style="padding: 0px; overflow: hidden;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
                    <div class="text-center" style="color: #FFF; overflow: hidden;">
                        <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
                    </div>
                </b-modal>
            </div>
        </b-popover>
    </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import { DateTime } from 'luxon'
  import moment from 'moment'
  import * as d3 from 'd3'

  export default {
    name: 'career-stream-skill-progress',
    props: ['title', 'careerId', 'streamId', 'skillProgressTargetId'],
    data: () => {
      return {
        progress: null,
        isPieChartGenerated: false
      }
    },

    mounted () {
      this.loadSkillProgress(false)
    },

    updated () {
      this.$nextTick(() => {
        if (this.progress) {
          let colorScale = {
            'completed': '#528016',
            'in progress': '#a1c75f',
            'scheduled': '#f5b318',
            'credits needed': '#cf7908'
          }
          this.generatePieChart(this.progress.values, colorScale, 'skillProgressChart')
        }
      })
    },

    methods: {
      ...mapActions([
        'loadCareerSkillProgress'
      ]),

      showLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.show()
        }
      },

      hideLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.hide()
        }
      },

      closeSkillProgressPopup () {
        this.$parent.selectedStream = null
        this.$parent.skillProgressTargetId = ''
        this.$parent.showStreamSkillProgressPopup = false
      },

      loadSkillProgress (isRecalculate) {
        this.showLoader()
        this.isPieChartGenerated = false
        this.loadCareerSkillProgress({streamId: this.streamId, careerId: this.careerId, recalculate: isRecalculate}).then(res => {
          this.progress = res
          setTimeout(() => {
            this.hideLoader()
          }, 500)
        })
      },

      generatePieChart (data, colorScale, elementId) {
        $('#' + elementId).empty()
        var pieChartContainerHeight = 162
        var pieChartInnerRadius = 35
        var width = pieChartContainerHeight
        var height = pieChartContainerHeight
        var radius = pieChartContainerHeight / 2

        var canvas = d3.select('#' + elementId).append('svg')
                     .data([data]).attr('width', width).attr('height', height).append('g')
                     .attr('transform', 'translate(' + radius + ',' + radius + ')')

        var arc = d3.arc()
                  .outerRadius(radius)
                  .innerRadius(pieChartInnerRadius)

        var pie = d3.pie()
                  .value(function (d) { return d.value }).sort(null)

        var arcs = canvas.selectAll('.arc')
                   .data(pie(data))
                   .enter().append('g')
                   .attr('class', 'arc')

        arcs.append('path')
            .attr('d', arc)
            .style('fill', function (d, i) { return colorScale[d.data.label] })

        arcs.append('text')
            .attr('transform', function (d) { return 'translate(' + arc.centroid(d) + ')' })
            .style('font', 'bold 12px Arial')
            .style('fill', '#fff')
            .style('cursor', 'default')
            .attr('text-anchor', 'middle')
            .text(function (d) { return d.data.value })

        this.isPieChartGenerated = true
      },

      changeMillisToDate (millis, format) {
        return DateTime.fromMillis(millis, {zone: 'utc'}).toFormat(format)
      },

      lastUpdatedDateTime (progress) {
        return (progress) ? this.changeMillisToDate(progress.lastUpdatedTime, 'MM/dd/yyyy @ hh:mm a') : ''
      },

      currentDateTime (progress) {
        let millis = moment().valueOf()
        if (progress && progress.currentTime) {
          millis = progress.currentTime
        }
        return this.changeMillisToDate(millis, 'MM/dd/yyyy (hh:mm a)')
      },

      recalculateSkillProgress () {
        this.loadSkillProgress(true)
      }
    }
  }
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/app/career/components/CareerStreamSkillProgress.vue